import { render, staticRenderFns } from "./HomeCardsSimilar.vue?vue&type=template&id=4720c5db&"
import script from "./HomeCardsSimilar.vue?vue&type=script&lang=js&"
export * from "./HomeCardsSimilar.vue?vue&type=script&lang=js&"
import style0 from "./HomeCardsSimilar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VCol,VContainer,VIcon,VRow,VThemeProvider})
